import { useParams } from 'react-router-dom'
import useQuery from '../../../hooks/useQuery'

export interface ParamsQuickSale {
    /**
     * Indica el modo en que se encuentra la página.
     */
    by: 'tables' | 'pre_orders'
}

export interface QueryParamsQuickSale {
    pre_order_id: string
    table_id: string
    /**
     * Entrega
     */
    diners?: string
}

export interface ParamsQuickSaleBy extends Omit<ParamsQuickSale, 'diners'> {
    preOrderId: string
    tableId: string
    diners: number
}

/**
 * Hook personalizado para obtener y normalizar los parámetros de la URL
 * en la página de venta rápida.
 *
 * Determina el modo de la página (`by`), que puede ser "tables" (venta por mesa) o "pre_orders" (pre-pedido),
 * así como los parámetros de la query string relevantes: `pre_order_id`, `table_id`, y opcionalmente `diners`.
 *
 * Devuelve un objeto con los valores tipados y normalizados para su uso en la lógica de QuickSaleBy.
 *
 * @returns {ParamsQuickSaleBy} Objeto con:
 *   - `by`: Indica si es 'tables' o 'pre_orders'.
 *   - `preOrderId`: ID del pre-pedido.
 *   - `tableId`: ID de la mesa.
 *   - `diners`: Número de comensales asociado (0 si no está presente).
 */
export default function useParamsQuickSaleBy(): ParamsQuickSaleBy {
    const { by } = useParams<ParamsQuickSale>()
    const { pre_order_id, table_id, diners } = useQuery<QueryParamsQuickSale>()

    const preOrderId = pre_order_id || ''
    const tableId = table_id || ''

    return {
        preOrderId,
        tableId,
        by,
        diners: diners ? Number(diners || 0) : 0
    }
}
